import React from 'react'
import StarIcon from "../../../../styles/img/svg/StarIcon"

export default function UiShopCard(props) {

    return (
        <>
            <div className='sb-content-card'>
                <div className='sb-content-card__inner'>
                    <div className='sb-content-card__head'>
                        {props.remainingTime && 
                            <div className='sb-content-card__remaining-time'>
                            <h4>{props.remainingTime}</h4>
                            </div>   
                         } 
                        <img src={props.cardImg} />
                    </div>

                    <div className='sb-content-card__body'>
                        <h3>{props.heading}</h3>
                        <p>{props.body}</p>
                    </div>

                    <div className='sb-content-card__footer-bottom'>
                        {props.points &&
                            <div className='sb-content-card__points-section'>
                                <div className='sb-content-card__points'>
                                    <span>{props.points} Points</span>
                                </div>
                            </div>
                        }
                        {props.rating &&
                        <div className='sb-content-card__ratings'>
                            <div className='sb-content-card__footer-ratings-content'>
                                    <StarIcon />
                                    <span>{props.rating} <span className='sb-content-card__reviews'>{props.reviews && '(' + props.reviews + ')'}</span></span>
                                </div>
                        </div>
                        }
                    </div>

                </div>

            </div>

        </>
    )
}
